import { useQuery } from '@apollo/client'
import { Hidden } from '@material-ui/core'

import PageHeader from '../../components/PageHeader'
import { GET_SESSIONS_QUERY } from '../../graphql/iamSessions'
import { getEmailFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { SessionsResponse } from '../../types/iamSessions'
import Header from './header'
import LoginAttempts from './loginAttempts'
import SessionsTable from './sessionsTable'
import useStyles from './styles/index.styles'

export default function Home() {
  const classes = useStyles()
  const { data: sessionsData, loading: loadingForGettingSessions } = useQuery<{
    sessions: SessionsResponse
  }>(GET_SESSIONS_QUERY, {
    // A session list is live state: State, Last Activity and both expiries are all relative
    // to now. Apollo defaults to cache-first and this query set no policy, so after the first
    // load the screen kept serving that snapshot -- a session whose 15-minute window had
    // lapsed nine hours earlier still rendered as Active, and only a full page reload (which
    // discards the cache) corrected it. cache-and-network keeps the instant render and then
    // refetches, matching what useCursorPage already does.
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        email: getEmailFromStorage(),
        pagination: { page: 1, perPage: 6 }
      }
    }
  })

  return (
    <div className={classes.root}>
      <PageHeader title={getTranslate('Home')} />
      <Header />
      <Hidden smDown>
        <SessionsTable
          loadingForGettingSessions={loadingForGettingSessions}
          sessionsData={sessionsData?.sessions}
        />
      </Hidden>
      <LoginAttempts />
    </div>
  )
}
